module.exports = __webpack_public_path__ + "img/login-image@2x.3f72b4ad.png";